import React, { useEffect, useState } from "react";

import { ReactComponent as PhoneIcon } from "../../assets/icon/bi_phone.svg";
import Button from "../../components/Common/Button";
const MobileAccessBanner = () => {
    const isWebSetting = localStorage.getItem('isWebSetting');
    const parseWebSetting = JSON.parse(isWebSetting);
    const isMobileAccessBannner = localStorage.getItem("isMobileAccessBannner");
    const [show, setShow] = useState(true);

    useEffect(() => {
        setShow(isMobileAccessBannner)
    }, [isMobileAccessBannner]);

    return (!show &&
        <div className="flex flex-row justify-center gap-2 bg-gradient-to-r from-[#22BDE2] to-[#FC00FF]  items-center relative">
            <div className="flex sm:flex-row flex-col gap-2 items-center z-10 py-3">
                <PhoneIcon className="h-6 w-6 hidden sm:inline-flex" fill="#ffffff" />
                <span className={` text-xs font-medium text-center text-darkColor`}>
                    Akses lebih cepat dengan aplikasi mobile {parseWebSetting?.judul}
                </span>
                <div>
                    <Button
                        initialValue="Download"
                        type="fill"
                        className=" border-1 h-7 text-xs  w-full text-darkColor border-[#ffffff]"
                        onClick={() => window.open(parseWebSetting?.playstore, '_blank')}
                    />
                </div>
            </div>
            <div className="absolute top-1 right-2 z-20 text-[#ffffff]"><button onClick={() => {
                localStorage.setItem("isMobileAccessBannner", true)
                setShow(false)
            }}>
                x</button>
            </div>
        </div>
    );
}

export default MobileAccessBanner;